// extracted by mini-css-extract-plugin
export var card = "_4f-0";
export var content = "_4f-1";
export var contentLoading = "_4f-2";